import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBusinessman, FcSelfServiceKiosk } from "react-icons/fc";
import CustomSelect from "../../../CustomComponent/custom_select";
import { courceSchema } from "../../../Schemas/Media And Marketing/cource_detail.schema";
import { useEffect } from "react";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { useParams } from "react-router-dom";
import { courceInfo } from "../../../SchemaInfo/info";

const EditCourcedetails = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  let { id } = useParams();
  const [socialMedia, setSocialMedia] = useState([]);
  const [courceInfor, setCourceInfor] = useState(courceInfo);
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/cource/get-cource/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setCourceInfor(res.data);
        } else {
          Toast("error", "Error while getting course!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handelSubmit = (values) => {
    performRequest("PATCH", `/cource/update/${id}`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Course updated successfully!");
          navigate(`/course-view/${id}`);
        } else {
          Toast("error", "Error while creating course details");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/podcast/social-media-users`)
      .then((res) => {
        if (res.status === 200) {
          setSocialMedia(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting social media!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/cource/get-all-courses`)
      .then((res) => {
        if (res.status === 200) {
          setCourses(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting courses!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcSelfServiceKiosk></FcSelfServiceKiosk> Courses
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit Topic Details</h2>
            </div>
            <Formik
              initialValues={courceInfor}
              validationSchema={courceSchema}
              onSubmit={handelSubmit}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Course Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="courceName"
                        ></CustomInput>
                        {props.touched.courceName &&
                          props.errors.courceName && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.courceName}{" "}
                            </p>
                          )}
                      </div>
                    </div> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Course Name
                      </label>
                      <div className="w-100 col">
                        {/* <CustomInput
                                              type={"text"}
                                              className="form-control"
                                              name="podcastEditor"
                                            ></CustomInput> */}

                        <CustomSelect name="courceName">
                          <option value="">Select</option>
                          {courses?.map((item, index) => {
                            return (
                              <option key={index} value={item?.id}>
                                {item?.courseName}
                              </option>
                            );
                          })}
                          {props.touched.courceName &&
                            props.errors.courceName && (
                              <p className="text-danger">
                                {" "}
                                {props.errors.courceName}{" "}
                              </p>
                            )}
                        </CustomSelect>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Topic Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="topicName"
                        ></CustomInput>
                        {props.touched.topicName && props.errors.topicName && (
                          <p className="text-danger">
                            {" "}
                            {props.errors.topicName}{" "}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Topic Script
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="topicScript"
                        ></CustomTextArea>
                        {props.touched.topicScript &&
                          props.errors.topicScript && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.topicScript}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Editor Name
                      </label>
                      <div className="w-100 col">
                        {/* <CustomInput
                          type={"text"}
                          className="form-control"
                          name="podcastEditor"
                        ></CustomInput> */}

                        <CustomSelect name="assignedTo">
                          <option value="">Select</option>
                          {socialMedia?.map((item, index) => {
                            return (
                              <option key={index} value={item?.userName}>
                                {item?.userName}
                              </option>
                            );
                          })}
                        </CustomSelect>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Deadline</label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="taskdedline"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Topic first draf nas url
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="courceUrl1"
                        ></CustomInput>
                        {props.touched.courceUrl1 &&
                          props.errors.courceUrl1 && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.courceUrl1}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Topic final nas url
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="courceUrl2"
                        ></CustomInput>
                        {props.touched.courceUrl2 &&
                          props.errors.courceUrl2 && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.courceUrl2}{" "}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className=" w-25 form-label col-3">
                        Published on website
                      </label>
                      <div className="w-100 col">
                        <CustomCheckbox
                          name={`markaspublished`}
                          type="checkbox"
                          height={"20px"}
                          width={"20px"}
                        ></CustomCheckbox>
                        {props.touched.markaspublished &&
                          props.errors.markaspublished && (
                            <p className="text-danger">
                              {props.errors.markaspublished}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Edit Course Topic Details" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default EditCourcedetails;
